<div class="position-relative">
  @for (step of steps(); track step; let i = $index) {
    <ziro-animated-image
      [lottiParams]="step"
      [ngStyle]="{ position: i === currentStep - 1 ? 'relative' : 'absolute', opacity: i === currentStep - 1 ? 1 : 0 }"
      [animationStart$]="replaySubjects[i].asObservable()"
    ></ziro-animated-image>
  }
</div>
